import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";

export default function AnalyticsRankingChart({ data, field, limit = 10 }) {
    const ranking = useMemo(() => {
        const totals = (Array.isArray(data) ? data : []).reduce((acc, item) => {
            const name = item[field] || "Не указано";
            acc[name] = (acc[name] || 0) + (Number(item.cnt) || 0);
            return acc;
        }, {});

        return Object.entries(totals)
            .sort((a, b) => b[1] - a[1])
            .slice(0, limit)
            .reverse();
    }, [data, field, limit]);

    const option = {
        animationDuration: 450,
        color: ["#2563eb"],
        grid: { left: 12, right: 58, top: 8, bottom: 8, containLabel: true },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            valueFormatter: value => `${new Intl.NumberFormat("ru-RU").format(value)} шт.`
        },
        xAxis: {
            type: "value",
            splitLine: { lineStyle: { color: "#e8eef6" } },
            axisLabel: { color: "#64748b" }
        },
        yAxis: {
            type: "category",
            data: ranking.map(([name]) => name),
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: "#334155", width: 135, overflow: "truncate" }
        },
        series: [{
            type: "bar",
            data: ranking.map(([, value]) => value),
            barMaxWidth: 22,
            itemStyle: { borderRadius: [0, 6, 6, 0] },
            label: { show: true, position: "right", color: "#334155", formatter: "{c}" }
        }]
    };

    return <ReactECharts option={option} style={{ height: 440, width: "100%" }} />;
}
